<template>
  <v-dialog v-model="visible" persistent max-width="839">
    <v-card class="v-dialog--custom v-dialog--custom-import" v-if="visible">
      <v-card-title class="headline pa-4">
        <span class="v-dialog--custom__title my-2">
          <Label :value="lines.length" colored error icon />
          <span class="ml-3">{{ $t(`${namespace}.title`) }}</span>
        </span>

        <v-btn
          class="v-dialog--custom__close mr-2"
          :disabled="isLoading"
          fab
          flat
          color="gray-6"
          @click="close"
        >
          <v-icon dark>close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text class="px-4 pt-0">
        <label style="position: relative;">
          <p v-if="isLoading">{{ $t('Views.BulkImportPage.uploadBox.status.loading') }}</p>
          <p v-else v-html="$t(`${namespace}.text`)" />

          <XLSXInput
            class="upload__input upload__input--hide"
            :maxLines="maxLines"
            :worksheetTarget="worksheetTarget"
            :supportedFileTypes="supportedFileTypes"
            @change="handleChange"
            @success="handleSuccess"
            @error="handleError"
          />
        </label>
      </v-card-text>

      <div class="table table-hover">
        <v-layout
          align-center
          class="grey--text text--darken-4 px-3 caption grey lighten-4 has-border-b table-header"
        >
          <v-flex v-if="isValidArray(lines) && isValidObject(lines[0])" xs2>{{ $t(`${namespace}.line`) }}</v-flex>
          <v-flex xs10>{{ $t(`${namespace}.error`) }}</v-flex>
        </v-layout>

        <v-list
          v-if="lines.length"
          class="v-list--reset table-body"
          subheader
          two-line
        >
          <div v-for="(line, i) in lines" :key="i">
            <v-list-tile class="list__item">
              <v-list-tile-content>
                <v-list-tile-sub-title>
                  <v-layout v-if="line && line.lineNumber && line.messages" align-center class="grey--text text--darken-4 px-3">
                    <v-flex xs2>{{ line.lineNumber }}</v-flex>
                    <v-flex xs10>
                      <span v-if="isValidArray(line.messages)" class="error--text">
                        <span v-if="line.sheetName">{{ line.sheetName }} - </span>{{ line.messages[0] }}
                      </span>
                      <span v-else>-</span>
                    </v-flex>
                  </v-layout>

                  <v-layout v-else align-center class="grey--text text--darken-4 px-3">
                    <v-flex xs12>{{ line }}</v-flex>
                  </v-layout>
                </v-list-tile-sub-title>
              </v-list-tile-content>
            </v-list-tile>

            <v-divider v-if="i < lines.length" />
          </div>
        </v-list>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import { isArray, isObject } from 'utils/functions'
import XLSXInputMixin from 'mixins/XLSXInput'
import uploadBoxMixin from 'mixins/uploadBox'
import Label from 'components/bulkImport/Label'
import XLSXInput from 'components/bulkImport/stepOne/XLSXInput'

export default {
  name: 'DialogLinesWithErrors',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    kind: {
      type: String
    },
    lines: {
      type: Array,
      default: () => []
    },
    maxLines: {
      type: Number
    },
    worksheetTarget: {
      type: [String, Array]
    },
    supportedFileTypes: {
      type: Array
    }
  },
  mixins: [XLSXInputMixin, uploadBoxMixin],
  components: {
    Label,
    XLSXInput
  },
  data () {
    return {
      namespace: 'Views.BulkImportPage.status.dialogLinesWithErrors',
      requestStatus: true
    }
  },
  methods: {
    close () {
      this.$emit('close')
    },

    isValidArray (val) {
      return isArray(val)
    },

    isValidObject (val) {
      return isObject(val)
    }
  }
}
</script>

<style lang="scss">
.v-dialog--custom-import {

  .v-dialog--custom__title {
    align-items: center;
    display: flex;
  }

  .table,
  .table-header,
  .table-body {
    max-width: 100%;
    min-width: 100%;
  }

  .table-hover .table-body .v-list__tile {
    cursor: default;
  }

  .upload__input--hide {
    left: -9999em;
    position: absolute;
    top: -9999em;
  }
}
</style>
